import services from "./../services";
import router from "./../router";
import Utils from "../Utils";
const strict = true;

const getDefaultState = () => {
  return {
    step: 1,
    passwordRecoveryRequest: null,
    token: null,
    username: null,
    password: null,
    confirmPassword: null
  };
};

const state = getDefaultState();

const getters = {
  step: state => state.step,
  passwordRecoveryRequest: state => state.passwordRecoveryRequest,
  token: state => state.token,
  username: state => state.username,
  password: state => state.password,
  confirmPassword: state => state.confirmPassword
};

const mutations = {
  RESET(state) {
    // acquire initial state
    const s = getDefaultState();
    Object.keys(s).forEach(key => {
      state[key] = s[key];
    });
  },
  SET_TOKEN(state, token) {
    state.token = encodeURIComponent(token.split("=")[1]);
  },
  SET_USERNAME(state, username) {
    state.username = username;
  },
  SET_PASSWORD(state, password) {
    state.password = password;
  },
  SET_CONFIRM_PASSWORD(state, confirmPassword) {
    state.confirmPassword = confirmPassword;
  }
};

const actions = {
  sendNewPasswordRequest({ commit, state }) {
    let payload = {
      token: state.token,
      username: state.username,
      password: state.password,
      portal: "HF"
    };
    return services.passwordRecoveryService
      .newPassword(payload)
      .then(() => {
        // redirect
        router.push({
          name: "login"
        });
      })
      .catch(error => {
        let errorDialogDetails = {
          ...error
        };
        if (error.type == Utils.errorTypes.STATUS) {
          errorDialogDetails.dataName = "newPassword";
        }

        commit("error/SET_ERROR", errorDialogDetails, {
          root: true
        });
      })
      .finally(() => {});
  },
  goBackToLogin({ commit }) {
    commit("RESET");
    router.push({
      name: "login"
    });
  }
};

export default {
  namespaced: true,
  strict,
  state,
  getters,
  mutations,
  actions
};
